import {lazy} from '@aboutyou/lazy-imports';

export const SlideInWebCouponBanner = lazy(() =>
  import('./SlideInWebCouponBanner.eager').then(mod => ({
    default: mod.SlideInWebCouponBanner,
  })),
);
